/**
* Loyalty Cache Management API Slice
* RTK Query endpoints for viewing and managing loyalty Redis caches
*/

import { rootApi } from "../../api/rootApi";

export const loyaltyCacheApi = rootApi.injectEndpoints({
  endpoints: (builder) => ({
    // Get cache status for a specific tenant
    getCacheStatus: builder.mutation({
      query: (params) => {
        return {
          method: "GET",
          url: `/admin/loyalty-cache/${params.tenantId}`,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + params.token,
          },
        };
      },
    }),

    // Clear all caches for a tenant
    clearAllCache: builder.mutation({
      query: (params) => {
        return {
          method: "DELETE",
          url: `/admin/loyalty-cache/${params.tenantId}`,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + params.token,
          },
          body: params.reason
            ? JSON.stringify({
              reason: params.reason,
              ruleId: params.ruleId,
            })
            : undefined,
        };
      },
    }),

    // Clear only rules cache (quick invalidation)
    clearRulesCache: builder.mutation({
      query: (params) => {
        return {
          method: "DELETE",
          url: `/admin/loyalty-cache/${params.tenantId}/rules`,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + params.token,
          },
          body: params.reason
            ? JSON.stringify({
              reason: params.reason,
              ruleId: params.ruleId,
            })
            : undefined,
        };
      },
    }),
  }),
});

export const {
  useGetCacheStatusMutation,
  useClearAllCacheMutation,
  useClearRulesCacheMutation,
} = loyaltyCacheApi;
